import { List } from 'immutable';
import _ from 'lodash';
import * as Constants from 'const';
import * as Models from 'models';
import { getAbbreviationIdsFromRelationOrDocument } from './getAbbreviationIdsFromDocumentsAndRelations';
import { isAbbreviationsListRelation } from './isAbbreviationsListRelation';

export function getCollectedAbbreviationIdsByRelations(
  relations: List<Models.LayeredRelationMap>,
  documents: Models.AppState.DocumentsMap,
  projectType: string,
  activeLayer: Constants.Layer = Constants.Layer.ORIGINAL,
): Record<string, string[]> {
  const abbreviationIdsMapping: Record<string, string[]> = {};

  let abbreviationsIds: string[] = [];
  for (const relation of relations) {
    if (isAbbreviationsListRelation(relation)) {
      const relationId: string = relation.get('id');
      abbreviationIdsMapping[relationId] = _.uniq(abbreviationsIds);
      abbreviationsIds = [];
    } else {
      const abbrIds = getAbbreviationIdsFromRelationOrDocument(relation, documents, activeLayer, projectType);
      abbreviationsIds.push(...abbrIds);
    }
  }

  return abbreviationIdsMapping;
}
